export const IMPORT_BARBERS = 'IMPORT_BARBERS';
export const IMPORT_SINGLE_BARBER = 'IMPORT_SINGLE_BARBER';
export const SET_SINGLE_BRAND_BARBER = 'SET_SINGLE_BRAND_BARBER';
export const RESET_SINGLE_BRAND_BARBER = 'RESET_SINGLE_BRAND_BARBER';
export const GET_SINGLE_BRAND_BARBER = 'GET_SINGLE_BRAND_BARBER';

export const IMPORT_SINGLE_BARBER_APPOINTMENTS = 'IMPORT_SINGLE_BARBER_APPOINTMENTS';
export const UPDATE_BARBER = 'UPDATE_BARBER';
export const ADD_BARBER = 'ADD_BARBER';
export const ADD_BARBER_PHOTO = 'ADD_BARBER_PHOTO';
export const BARBER_BUSY_DAY = 'BARBER_BUSY_DAY';
export const DELETE_BARBER = 'DELETE_BARBER';
export const BARBER_BUSY_TIME = 'BARBER_BUSY_TIME';
export const GET_BARBERS = 'GET_BARBERS';
export const GET_DELETED_BARBERS = 'GET_DELETED_BARBERS';
export const RESTORE_SINGLE_BARBER = 'RESTORE_SINGLE_BARBER';
export const ADD_BLOCK_TIME = 'ADD_BLOCK_TIME';
export const ADD_BLOCK_TIME_SUCCESS = 'ADD_BLOCK_TIME_SUCCESS';
export const EDIT_BLOCK_TIME = 'EDIT_BLOCK_TIME';
export const DELETE_BLOCK_TIME = 'DELETE_BLOCK_TIME';
export const RESET_AVAILABLE_TIMES = 'RESET_AVAILABLE_TIMES';
export const REQUEST_AVAILABLE_TIMES = 'REQUEST_AVAILABLE_TIMES';
export const RECEIVE_AVAILABLE_TIMES = 'RECEIVE_AVAILABLE_TIMES';
export const USE_SERVICE_DURATION_FOR_TIMES = '-1';
export const UPDATE_BARBER_ORDER = 'UPDATE_BARBER_ORDER';
export const FETCH_NEXT_AVAILABLE_TIMES = 'FETCH_NEXT_AVAILABLE_TIMES';
export const FETCH_NEXT_AVAILABLE_TIMES_SUCCESS = 'FETCH_NEXT_AVAILABLE_TIMES_SUCCESS';
export const FETCH_NEXT_AVAILABLE_TIMES_ERROR = 'FETCH_NEXT_AVAILABLE_TIMES_ERROR';
export const BARBER_UPDATED = 'BARBER_UPDATED';

export const BARBER_SET_PERMISSION_CODE_LOADING = 'BARBER_SET_PERMISSION_CODE_LOADING';
export const BARBER_SET_PERMISSION_CODE_LOADED = 'BARBER_SET_PERMISSION_CODE_LOADED';
export const SET_BRAND_BARBER_PERMISSION_CODE = 'SET_BRAND_BARBER_PERMISSION_CODE';
export const ADD_BRAND_BARBER_DAY_OFF = 'ADD_BRAND_BARBER_DAY_OFF';
export const REMOVE_BRAND_BARBER_DAY_OFF = 'REMOVE_BRAND_BARBER_DAY_OFF';


export const BARBER_GET_DAYS_ON_BY_SHOP = 'BARBER_GET_DAYS_ON_BY_SHOP';
export const BARBER_SET_DAYS_ON_BY_SHOP = 'BARBER_SET_DAYS_ON_BY_SHOP';
export const BARBER_GET_DAYS_ON_BY_SHOP_ERROR = 'BARBER_GET_DAYS_ON_BY_SHOP_ERROR';

export const BARBER_GET_DAYS_OFF_BY_SHOP = 'BARBER_GET_DAYS_OFF_BY_SHOP';
export const BARBER_SET_DAYS_OFF_BY_SHOP = 'BARBER_SET_DAYS_OFF_BY_SHOP';
export const BARBER_GET_DAYS_OFF_BY_SHOP_ERROR = 'BARBER_GET_DAYS_OFF_BY_SHOP_ERROR';

export const BARBER_GET_SCHEDULES = 'BARBER_GET_SCHEDULES';
export const BARBER_SET_SCHEDULES = 'BARBER_SET_SCHEDULES';
export const BARBER_GET_SCHEDULES_ERROR = 'BARBER_GET_SCHEDULES_ERROR';
